<template>
  <div>
    <div class="columns is-marginless is-paddingless section section-details">
      <div class="column is-10">
        <div class="card mgt-20px" id="generalInformations">
          <header class="header-card">
            <p>
              {{ $t('detailFournisseurSupport.informationsGenerales.title')}}
            </p>
          </header>
          <info-generales :fournisseurSupport="fournisseurSupport"></info-generales>
        </div>
        <div class="card mgt-20px" id="contacts">
          <header class="header-card">
            <p>
              {{ $t('detailFournisseurSupport.contacts.title')}}
            </p>
          </header>
          <contacts :tier="fournisseurSupport"></contacts>
        </div>
        <div class="card mgt-20px" id="bankDetails">
          <header class="header-card">
            <p>
              {{ $t('detailFournisseurSupport.infoBancaire.title')}}
            </p>
          </header>
          <info-bancaires :fournisseurSupport="fournisseurSupport"></info-bancaires>
        </div>
        <div class="columns mgt-20px">
          <div class="column is-6">
            <div class="card">
              <header class="header-card">
                <p>
                  {{ $t('detailFournisseurSupport.infoCompta.title')}}
                </p>
              </header>
              <info-comptables :fournisseurSupport="fournisseurSupport"></info-comptables>
            </div>
          </div>
          <div class="column is-6">
            <info-commande :tiers="fournisseurSupport"></info-commande>
          </div>
        </div>
        <div class="card mgt-20px">
          <header class="header-card">
            <p>
              {{ $t('detailFournisseurSupport.infoBlocagePaiement.title')}}
            </p>
          </header>
          <info-blocage-paiement :fournisseurSupport="fournisseurSupport"></info-blocage-paiement>
        </div>
        <div class="card mgt-20px" id="comments">
          <header class="header-card">
            <p>
              {{ $t('detailFournisseurSupport.commentaires.title')}}
            </p>
          </header>
          <div class="card-content has-text-default is-size-7">
            {{ fournisseurSupport.commentairesInternes}}
          </div>
        </div>
        <div class="card mgt-20px" id="attachments">
          <header class="header-card">
            <p>
              {{ $t('detailFournisseurSupport.piecesJointes.title')}}
            </p>
          </header>
          <div class="card-content">
            <app-pieces-jointes
              :checkPermissions="checkPermissions(permsFournisseurSupport.maj)"
              readOnly deletable autoSave
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="is-fixed mgt-20px">
          <dots-menu :steps="steps">
          </dots-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DotsMenu from '@/components/general/dotsMenu';
import infoGenerales from '@/components/achat/fournisseurSupport/detailFournisseurSupport/infoGenerales';
import contacts from '@/components/tiers/contacts/contacts';
import infoBancaires from '@/components/achat/fournisseurSupport/detailFournisseurSupport/infoBancaires';
import infoComptables from '@/components/achat/fournisseurSupport/detailFournisseurSupport/infoComptables';
import infoBlocagePaiement from '@/components/achat/fournisseurSupport/detailFournisseurSupport/infoBlocagePaiement';
import PiecesJointes from '@/components/general/piecesJointes';
import infoCommande from '@/components/commun/tiers/detailTiers/infoCommande';
import { FOURNISSEUR_SUPPORT } from '@/configuration/presse/permissionsPresseConf';
import { createNamespacedHelpers } from 'vuex';

const permissions = createNamespacedHelpers('permissions');

export default {
  name: 'detailFournisseurSupport',
  props: {
    fournisseurSupport: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      permsFournisseurSupport: FOURNISSEUR_SUPPORT,
      steps: [
        {
          name: this.$i18n.t('detailFournisseurSupport.steps.infoGenerales'),
          ref: '#generalInformations',
          active: true,
        },
        {
          name: this.$i18n.t('detailFournisseurSupport.steps.contacts'),
          ref: '#contacts',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseurSupport.steps.infoBancaire'),
          ref: '#bankDetails',
          active: false,
        },
        {
          name: this.$i18n.t('detailTiers.steps.commande'),
          ref: '#infoCommande',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseurSupport.steps.commentaires'),
          ref: '#comments',
          active: false,
        },
        {
          name: this.$i18n.t('detailFournisseurSupport.steps.piecesJointes'),
          ref: '#attachments',
          active: false,
        },
      ],
    };
  },
  components: {
    DotsMenu,
    infoGenerales,
    contacts,
    infoBancaires,
    infoComptables,
    infoBlocagePaiement,
    appPiecesJointes: PiecesJointes,
    infoCommande,
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
};
</script>

<style scoped>

</style>
